var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigliorRapportoQualitaPrezzo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1892_9691",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1892_9691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.95503V14.78L15.225 16.68L14.375 13.08L17.15 10.705L13.475 10.38L12 6.95503ZM12 16.88L7.89998 19.33C7.71665 19.43 7.53748 19.4717 7.36248 19.455C7.18748 19.4384 7.03331 19.38 6.89998 19.28C6.76665 19.18 6.66665 19.0425 6.59998 18.8675C6.53331 18.6925 6.52498 18.5134 6.57498 18.33L7.64998 13.755L4.02498 10.68C3.87498 10.5467 3.78331 10.3925 3.74998 10.2175C3.71665 10.0425 3.72498 9.8717 3.77498 9.70503C3.82498 9.53836 3.91665 9.40086 4.04998 9.29253C4.18331 9.1842 4.34998 9.1217 4.54998 9.10503L9.29998 8.68003L11.175 4.33003C11.2583 4.1467 11.375 4.0092 11.525 3.91753C11.675 3.82586 11.8333 3.78003 12 3.78003C12.1666 3.78003 12.325 3.82586 12.475 3.91753C12.625 4.0092 12.7416 4.1467 12.825 4.33003L14.7 8.70503L19.45 9.10503C19.65 9.1217 19.8166 9.18836 19.95 9.30503C20.0833 9.4217 20.175 9.56336 20.225 9.73003C20.275 9.8967 20.2791 10.0634 20.2375 10.23C20.1958 10.3967 20.1 10.5467 19.95 10.68L16.35 13.755L17.425 18.33C17.475 18.5134 17.4666 18.6925 17.4 18.8675C17.3333 19.0425 17.2333 19.18 17.1 19.28C16.9666 19.38 16.8125 19.4384 16.6375 19.455C16.4625 19.4717 16.2833 19.43 16.1 19.33L12 16.88Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigliorRapportoQualitaPrezzo);
export default __webpack_public_path__ + "static/media/miglior_rapporto_qualita_prezzo.7a7ee4fd92919aba6ce4d220c1cd3e0e.svg";
export { ForwardRef as ReactComponent };